define([],function () {
    return function iterate(obj, cb, start) {
            var stopFlag = false;
            var data = null;
            function stop(data) {
                data = data;
                stopFlag = true;
            }

            function isObject(value) {
                return value && typeof value === 'object' && value.constructor === Object;
            }

            var element;
            if (isObject(obj)) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        element = obj[key];
                        if (!stopFlag) {
                            cb(element, key, obj, stop);
                        } else break;
                    }
                }
            } else if (typeof obj === "number") {
                if (!start) {
                    start = 1
                }
                for (start; start <= obj; start++) {
                    if (!stopFlag) {
                        cb(start, start, obj, stop);
                    } else break;
                }
            } else {
                var l = obj.length;
                for (var i = 0; i < l; i++) {
                    element = obj[i];
                    if (!stopFlag) {
                        cb(element, i, obj, stop);
                    } else break;
                }
            }

            return stopFlag ? {
                stopFired: true,
                data: data
            } : {
                stopFired: false,
            }
        }
});
